let navigationData = require("./navigation-data.json");

export const firstTile = "lacantina_product_featured_item";
export const navDataWide = navigationData.navDataWide;
export const navDataMobile = navigationData.navDataMobile;
